<template>
  <div
    class="text-center"
  >
    <v-img
        src="../assets/img/background_1.svg"
        contain
        class="backgroundH"
      >
        <content-home />
    </v-img>

     <!-- <v-img
        contain
        width="100vh"
        class="backgroundV"
      > -->

        <v-row
            align="center"
            justify="center"
            class="backgroundV"
          >

        <p class="text pt-6 pl-3 pr-3 backgroundV"> Este site na versão mobile na
          orientação vertical está em construção.</p>

        <p class="text pb-6 pl-3 pr-3 backgroundV"> Por favor, acesse pelo tablet na
          orientação horizontal ou computador!</p>

            <v-card flat class="transparent">
              <v-img
                src="../assets/img/logo_v.svg"
                width="40vh"
              />
            </v-card>
        </v-row>

     <!-- </v-img> -->
</div>
</template>

<script>
import ContentHome from '@/components/ContentHome.vue';

export default {
  name: 'home',
  components: {
    ContentHome,
  },
};
</script>

<style scoped>
.text {
  margin-bottom: 10px;
  font-weight: 600;
  color: var(--v-tertiary-base);
  font-size: 1.2em;
}

.v-application .text {
  background-color: white !important;
}

.transparent {
  background-color: transparent;
}
</style>
